import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.interface';
import { ProductLetterType } from '../../../shared/models/product-letter.interface';

export interface TestEmailPayload {
  email: string;
  content: string;
  product_id: string;
  letter_type: ProductLetterType;
}
@Injectable({
  providedIn: 'root',
})
export class TestEmailService {
  constructor(private apiService: HttpService) {}

  send(payload: TestEmailPayload): Observable<ApiResponse> {
    return this.apiService.postReq(`/send-letter-preview`, payload);
  }
}
